module.exports = __webpack_public_path__ + "img/5.20c4a9f6.jpg";